<template>
	<div>
		<el-row>
			<el-card class="box-card">
				<el-form ref="form" :model="queryParams" :rules="searchRules" label-width="110px" label-position="right">
					<!--<el-row class="row-content">
						<el-col :span="24">
							<el-form-item label="咨询类别:" prop="zxlb">
								<el-radio-group v-model="searchForm.zxlb">
									<el-radio v-for="dict in zxlbOptions" :key="dict.dictValue" :label="dict.dictValue">
										{{dict.dictLabel}}
									</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>-->
					<el-row class="row-content">
						<el-col :span="24">
							<el-form-item label="咨询业务:" prop="zxyw">
								<el-radio-group v-model="queryParams.zxywName">
									<el-radio v-for="dict in zxywOptions" :key="dict.dictValue" :label="dict.dictValue">
										{{dict.dictLabel}}
									</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row class="row-content">
						<!--<el-col :span="12">
							<el-form-item label="地区" prop="region">
								<el-select v-model="searchForm.region" size="medium" clearable>
								  <el-option
								    v-for="item in orgcodeOptions"
								    :key="item.deptCode"
								    :label="item.shortName"
								    :value="item.deptCode">
								  </el-option>
								</el-select>
							</el-form-item>
						</el-col>-->
						<el-col :span="24">
							<el-form-item label="标题:" prop="title">
								<el-input v-model="queryParams.title" placeholder="请输入标题" />
							</el-form-item>
						</el-col>
					</el-row>
					<el-row class="row-content">
						<el-col :span="12">
							<el-form-item>
								<el-button type="primary" size="small" @click="getList">搜 索</el-button>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</el-card>
			<el-row class="content">
				<el-table v-loading="loading" :data="list" ref="table"
				:header-cell-style="{backgroundColor:'#e2e2e2'}" style="width: 100%">
					<el-table-column label="序号" type="index" width="50" />
					<el-table-column label="标题" align="center" prop="title":show-overflow-tooltip="true"/> 
<!--					<el-table-column label="状态" align="center" prop="status" width="70"/>-->
					<el-table-column label="咨询时间" align="center" prop="createTime">
						<template slot-scope="scope">
							<span>{{ parseTime(scope.row.createTime, '{y}-{m}-{d}') }}</span>
						</template>
					</el-table-column>
					<el-table-column label="受理状态" align="center" prop="hfType" width="70">
						<template slot-scope="scope">
							{{transfHfType(scope.row.hfType)}}
						</template>
					</el-table-column>
<!--					<el-table-column label="受理时间" align="center" prop="acceptTime" />-->
					<el-table-column label="操作" align="center" prop="recid" width="200"> 
			            <template slot-scope="scope">
<!--							<el-button size="mini" type="text">撤销</el-button>-->
<!--							<el-button size="mini" type="text" @click="toPage('/main/zxzxForm')">编辑</el-button>-->
<!--							<el-button size="mini" type="text">提交</el-button>-->
							<el-button size="mini" type="text" @click="toogleExpand(scope.row)">查看</el-button>
			            </template>
			        </el-table-column>
					<!-- 展开部分 -->
<!--					<el-table-column type="expand" width="1">-->
<!--						<template slot-scope="props">-->
<!--						  <el-form label-position="left" inline class="demo-table-expand" style="background-color: #f8f8ff;">-->
<!--								<div v-for="(item,index) in chatLogs.logs" :key="index" class="for-content">-->
<!--									<el-row>-->
<!--										<el-col :span="24" class="chat-time">-->
<!--											<span style="margin-right: 0.5rem;">■</span>-->
<!--											<span>{{item.chatTime}}</span>-->
<!--										</el-col>-->
<!--									</el-row>-->
<!--									<el-row>-->
<!--										<el-col :span="24" class="chat-content">-->
<!--											<span>{{item.chatContent}}</span>-->
<!--											<span v-if="chatLogs.logs.length-1 === index && !item.isReply" class="reply" @click="replyModal(item)">回复</span>-->
<!--										</el-col>-->
<!--									</el-row>-->
<!--								</div>-->
<!--								<div>-->
<!--									<el-row class="orgname">-->
<!--										<el-col :span="24">-->
<!--											<span>单位名称：{{chatLogs.orgname}}</span>-->
<!--										</el-col>-->
<!--									</el-row>-->
<!--								</div>-->
<!--						  </el-form>-->
<!--						</template>-->
<!--					</el-table-column>-->
				</el-table>
				<pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum"
					:limit.sync="queryParams.pageSize" @pagination="getList" />
				<!--回复内容-->
<!--				<el-dialog :title="replyOptions.title" :visible.sync="replyOptions.replyOpen" width="600px" append-to-body>-->
<!--				  <el-form ref="form" :model="replyForm" :rules="replyOptions.replyRules" label-width="100px">-->
<!--				    <el-row>-->
<!--				      <el-col :span="24">-->
<!--				        <el-form-item label="回复内容" prop="chReason">-->
<!--				          <el-input type="textarea" v-model="replyForm.replyContent" placeholder="请输入内容"-->
<!--				                    :autosize="{ minRows: 4, maxRows: 6}"/>-->
<!--				        </el-form-item>-->
<!--				      </el-col>-->
<!--				    </el-row>-->
<!--				  </el-form>-->
<!--				  <div slot="footer" class="dialog-footer">-->
<!--				    <el-button type="success" @click="submitReply(replyForm.chatRecid)">提 交</el-button>-->
<!--				    <el-button @click="cancel">取 消</el-button>-->
<!--				  </div>-->
<!--				</el-dialog>-->
			</el-row>
		</el-row>
		<el-dialog :title="detailTitle" :visible.sync="detailOpen" width="40rem" append-to-body :close-on-click-modal="false">
			<el-row>
				<el-col :span="4">咨询标题：</el-col>
				<el-col :span="20" style="color:#8f8f94;font-size: 0.8rem">{{detail.title}}</el-col>

			</el-row>
			<hr>
			<el-row>
				<el-col :span="4">咨询内容：</el-col>
				<el-col :span="20" style="color:#8f8f94;font-size: 0.8rem">{{detail.content}}</el-col>
			</el-row>
			<el-divider>回复记录</el-divider>
			<el-row class="content">
				<el-col :span="24">
				<el-table v-loading="detailLoading" :data="detail.list" ref="detailTable"
						  :header-cell-style="{backgroundColor:'#e2e2e2'}" >
					<el-table-column label="序号" type="index" width="50" />
					<el-table-column label="回复内容" prop="content" :show-overflow-tooltip="true"  />
					<el-table-column label="回复单位" prop="replyDept" />
					<el-table-column label="回复时间" prop="replyTime"   />
				</el-table>
				</el-col>
			</el-row>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getListDept
	} from "@/api/system/dept";
	import{findAll,findReplyAll,findZxzxYw} from "@/api/zxzx/zxzx";
	export default {
		name: 'qygzsZxclcx',
		data(){
			return{
				searchForm:{
					
				},
				searchRules:{
					
				},
				zxlbOptions:[],
				zxywOptions:[],
				orgcodeOptions:[],
				deptQueryParams:{
					deptLevel:'3',
					deptCode:'3710'
				},
				// 遮罩层
				loading: false,
				// 总条数
				total: 0,
				list: [],
				queryParams: {
					pageNum: 1,
					pageSize: 10
				},
				chatLogs:{
					
				},
				replyOptions: {
				  title: '回复信息',
				  replyOpen: false,
				  replyRules:{
				    replyContent: [
				      { required: true, message: '请输入回复信息', trigger: 'blur' },
				      { min: 1, max: 500, message: '长度在 1 到 500 个字符', trigger: 'blur' }
				    ],
				  },
				},
				replyForm:{
					chatRecid:undefined,
					replyContent:undefined
				},
				ywFwjgRecid:undefined,
				hfTypes: [],
				detailTitle:undefined,
				detailOpen:false,
				detail:{},
				detailLoading:false,
			}
		},
		created() {
			this.getDicts("zxzx_hfType").then(response => {
				this.hfTypes = response.data;
			});
			this.getDicts("yw_zxzx_zxlb_type").then(response => {
			    this.zxlbOptions = response.data;
			});
			// this.getDicts("yw_zxzx_zxyw").then(response => {
			//     this.zxywOptions = response.data;
			// });

			// this.getdeptlist();
			this.getZxywOptions();
			let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
			if(ssessionLoginUser != null && ssessionLoginUser != undefined){
				this.ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
			}
			this.getList();
		},
		methods:{
			getZxywOptions(){
				findZxzxYw().then(response =>{
					this.zxywOptions = response.data;
				});
			},
			toPage(url) {
				this.utils.windowOpen(url);
			},
			getdeptlist(){
				getListDept(this.deptQueryParams).then(res => {
					this.orgcodeOptions = res.data;
				})
			},
			getList() {
				this.loading = true;
				this.queryParams.ywFwjgRecid = this.ywFwjgRecid;
				findAll(this.queryParams).then(response =>{
					this.list = response.rows;
					this.total = response.total;
					this.loading = false;
				});
				// let that = this;
				// setTimeout(function() {
				// 	that.loading = false;
				// 	that.list = [{
				// 			recid: '1',
				// 			title: '转让专利被恶意调换，怎么办？',
				// 			status: '已提交',
				// 			submitTime: '2021-09-09 13:22:11',
				// 			acceptStatus: '待受理',
				// 			acceptTime: '2021-09-09 13:25:00',
				//
				// 		},{
				// 			recid: '2',
				// 			title: '专利被转让后再次被转让第三家，如果...',
				// 			status: '已提交',
				// 			submitTime: '2021-09-09 13:22:11',
				// 			acceptStatus: '待受理',
				// 			acceptTime: '2021-09-09 13:25:00',
				// 		},{
				// 			recid: '3',
				// 			title: '发布服务后，想撤销怎么办？',
				// 			status: '已受理',
				// 			submitTime: '2021-09-09 13:22:11',
				// 			acceptStatus: '待受理',
				// 			acceptTime: '2021-09-09 13:25:00',
				// 		},{
				// 			recid: '4',
				// 			title: '转让发布如何设置为询价？',
				// 			status: '已办结',
				// 			submitTime: '2021-09-09 13:22:11',
				// 			acceptStatus: '待受理',
				// 			acceptTime: '2021-09-09 13:25:00',
				// 		},
				// 	];
				// 	that.total = 4;
				// }, 500);
				// that.chatLogs={
				// 	orgname:'知识产权事业中心',
				// 	logs:[
				// 		{
				// 			recid:'1',
				// 			chatTime:'2021-10-02 09:11:21',
				// 			chatContent:'咨询已被受理，将有专人为您解答'
				// 		},
				// 		{
				// 			recid:'2',
				// 			chatTime:'2021-10-02 11:20:33',
				// 			chatContent:'您在转让发布页面中，将参考价格置空，系统将会默认为询价。',
				// 			isReply:false
				// 		},
				// 	]
				// }
			},
			// 展开行效果
			toogleExpand(row) {
			  // const $table = this.$refs.table
			  // // 注意，这里的 this.list 是上面 data 中的 list
			  // // 通过比对数据与行里的数据，对展开行进行控制，获取对应值
			  // this.list.map((item) => {
				// if (row.id !== item.id) {
				//   $table.toggleRowExpansion(item, false)
				// }
			  // })
			  // $table.toggleRowExpansion(row)
				this.detail={};
				this.detailOpen=true;
				this.detailTitle="咨询详情";
				this.detail.title=row.title;
				this.detail.content=row.content;
				this.detailLoading = true;
				let detailQuery = {};
				detailQuery.zxzxRecid = row.recid;
				findReplyAll(detailQuery).then(response =>{
					this.detail.list = response.data;
					console.log(response.data)
					this.detailLoading = false;
				});
			},
			replyModal(item){
				this.replyOptions.replyOpen = true;
				this.replyForm.chatRecid = item.recid;
			},
			submitReply(chatRecid) {
				this.msgSuccess("提交成功");
				this.replyOptions.replyOpen = false;
				
			},
			cancel(){
				this.replyForm.replyContent = undefined;
				this.replyOptions.replyOpen = false;
			},
			transfHfType(value){
					return this.selectDictLabel(this.hfTypes, value);
			},
		}
	}
	
</script>

<style scoped="scoped">
	.box-card{
	}
	.row-content{
		text-align: left;
	}
	.el-radio-group{
		line-height: 1.875rem;
	}
	.content{
		margin-top: 0.9375rem;
	}
	.for-content{
		padding: 0.625rem;
	}
	.chat-time{
		line-height: 1.25rem;
		padding: 0.625rem 1.25rem;
		text-align: left;
	}
	.chat-content{
		line-height: 1.25rem;
		padding: 0.625rem 0 0 3rem;
		text-align: left;
		color: #7574aa;
	}
	.orgname{
		margin-top: 1rem;
		text-align: right;
		padding: 0 1rem 1rem 0;
	}
	.reply{
		color: #409EFF;
		cursor: pointer;
	}
</style>
